import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OrderItemService {
  constructor(private http: HttpClient) {}

  public getOrderItemDetail(id: number, buyerEmail: string): Observable<any> {
    return this.http.get(
      `${environment.THIRD_PARTY_API_URL}/order-items/return-details/?id=${id}&buyerEmail=${buyerEmail}`
    );
  }
}
